import axios from "axios";
import { getBaseUrl } from "./getBaseUrl";
import { isUnderBaseDomain } from "./brandHost";

/**
 * The axios instance behind the no-login student profile page (/profile-form).
 *
 * NOT apiClient: that one attaches the signed-in user's token and treats a 401
 * as "logged out" — a redirect to the login page, which is exactly what this
 * page exists to avoid. The link token travels in every request BODY
 * (vc_be routes/publicStudentProfileRoutes.js), never in a header or the URL.
 *
 * The tenant headers mirror apiClient's, so an institute's own host resolves.
 */
const profileLinkClient = axios.create({
  baseURL: getBaseUrl(),
  headers: { "Content-Type": "application/json" },
});

profileLinkClient.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname.endsWith(".localhost")) {
      const sub = hostname.slice(0, -".localhost".length);
      if (sub) config.headers["X-Institute-Subdomain"] = sub;
    } else if (hostname && hostname !== "localhost" && !isUnderBaseDomain(hostname)) {
      config.headers["X-Custom-Domain"] = hostname;
    }
  }
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    config.headers.setContentType(undefined);
  }
  return config;
});

export default profileLinkClient;
